export const filter = {
  title: '',
  state: ''
};